import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { ToastrService } from 'ngx-toastr';

import { PrescriptionTemplate } from '../prescription-template';
import { PrescriptionTemplateService } from '../../service/prescription-template.service';

@Component({
  selector: 'mc-prescription-template-new',
  templateUrl: './prescription-template-new.component.html',
  styleUrls: ['./prescription-template-new.component.scss']
})
export class PrescriptionTemplateNewComponent implements OnInit {

  template: PrescriptionTemplate = new PrescriptionTemplate();

  constructor(
    private ptService: PrescriptionTemplateService,
    private location: Location,
    private notifService: ToastrService 
  ) { }

  ngOnInit() {
  }

  saveTemplate(): void {
    if (!this.template) { return; }
    this.ptService.createPrescriptionTemplate(this.template).subscribe(
      template => {
        this.template = template;
        this.notifService.success('Receita adicionada');
        this.location.back();
      },
      error => this.notifService.error(error)
    );
  }

  goBack(): void {
    this.location.back();
  }
}
